import { Flex, Link, Card, CardHeader, CardBody, CardFooter, Image, Text, Divider, Stack, HStack, Button } from "@chakra-ui/react"
import kcookingtrip from '../assets/images/kcookingtrip.png';
import googlebtn from '../assets/images/google_btn.png';
import applebtn from '../assets/images/apple_btn.svg';
const redirectToURL = () => {
  window.location.href = "https://kcookingtrip.onelink.me/YWsf/upisfprg";
};

function KCookingTrip() {
  return (
    <Flex alignItems="center" justifyContent="center" flex="1" bgColor="#646AB0">
    <Card maxW="sm" overflow="hidden" padding={2}>
      <Image
        src={kcookingtrip}
        alt="k-cookingtrip"
      />
      <CardHeader>
        <Text fontSize="xl" fontWeight="bold">K-CookingTrip</Text>
      </CardHeader>
      <CardBody>
        <Text whiteSpace="pre-line">
        K-Cooking Trip, Finally Launched!{'\n'}{'\n'}
Manage your own restaurant in Korea's famous landmarks and trendy hotspots.{'\n'}{'\n'}
Enjoy the daily charm of unique chefs, realistic dishes, and delightful customers.{'\n'}{'\n'}
With an idle tycoon system, anyone can play and have fun effortlessly!{'\n'}{'\n'}
        </Text>

        <Divider />

        <HStack spacing={6} justify="center">
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={applebtn} alt="Button 1" width="140px" />
            </Button>
            <Button onClick={redirectToURL} variant="unstyled">
              <Image src={googlebtn} alt="Button 2" width="140px" />
            </Button>
          </HStack>

      </CardBody>
      <CardFooter>
        <Stack>
        <Text fontSize="14px">If you need assistance or have any inquiries while using the app, please refer to the information below:</Text>
        <Text fontSize="14px" whiteSpace="pre-line" fontWeight="semibold">Email:{" "}
          <Link href="mailto:support@dodo-dot.com" color="blue.500" fontWeight="bold">
            support@dodo-dot.com
          </Link>
        </Text>
        <Text fontSize="14px" whiteSpace="pre-line" fontWeight="semibold">Privacy Policy{'\n'}
          <Link href="https://www.dodo-dot.com/privacy-policy" color="blue.500" fontWeight="bold">
            https://www.dodo-dot.com/privacy-policy
          </Link>
        </Text>
        <Text fontSize="14px">For additional questions, feel free to contact us via email.</Text>
      </Stack>
        {/* <Button variant="solid" colorScheme="blue">Buy now</Button>
        <Button variant="ghost">Add to cart</Button> */}
      </CardFooter>
    </Card>
    </Flex>
  )
}

export default KCookingTrip;
